<template>
  <el-dialog :title="titleLabel[dialogStatus] + '收入'" :visible.sync="dialogVisible" class="mx-50" top="40px">
    <table width=100%>
      <tr>
        <th width=30%>收入总额</th>
        <th width=30% >未确认金额</th>
        <th width=30% >已确认金额</th>
        <th width=10% ></th>
        <th></th>
      </tr>
      <tr>
        <td>{{adjust_commission}}</td>
        <td>{{modify_unconfirmed_amount}}</td>
        <td>{{modify_confirmed_amount}}</td>
        <td></td>
      </tr>
    </table>
    <el-divider></el-divider>

    <el-form :rules="rules" ref="dataForm" :model="formData" label-position="left" label-width="150px" class="mx-30">
      <el-form-item prop="income_type" label="收入类型">
        <el-select v-model="formData.income_type" placeholder="请选择收入类型" :disabled="isDisabled" >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="insurance_company" label="业务单位明细">
        <el-select v-model="formData.insurance_company" placeholder="请业务单位明细" class="w-100" @change="handleSelected">
          <el-option
            v-for="item in accountOptions"
            :key="item.value"
            :label="item.label"
            :value="item.label">
          </el-option>
        </el-select>

      </el-form-item>
      <el-form-item prop="amount" label="税价合计">
        <el-input v-model="formData.amount" autoComplete="on"></el-input>
      </el-form-item>
      <el-form-item prop="vat" label="税价">
        <el-input v-model="vat" autoComplete="on" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item prop="sales" label="销售额" >
        <el-input v-model="sales" autoComplete="on" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item
        prop="invoiced_amount" label="开票金额">
        <el-input v-model="invoiced_amount" autoComplete="on" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item prop="non_invoiced_amount" label="不开票金额">
        <el-input v-model="non_invoiced_amount" autoComplete="on" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item v-if="formData.income_type==1"
        prop="invoice_number" label="发票号">
        <el-input type="number" v-model="formData.invoice_number" autoComplete="on"></el-input>
      </el-form-item>
      <el-form-item v-if="formData.income_type==1"
        prop="taxpayer_id" label="纳税人识别号">
        <el-input v-model="formData.taxpayer_id" autoComplete="on" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item v-if="formData.income_type==1"
        prop="invoiced_date" label="开票日期">
        <el-date-picker
          v-model="formData.invoiced_date"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="source_document" label="发票">
        <el-upload
          :data="formData"
          ref="upload"
          :headers="headers"
          action=""
          :file-list="source_document_list"
          list-type="picture"
          :limit="2"
          :on-remove="handleRemoveSourceDocument"
          :on-preview="handlePreviewSourceDocument"
          :on-change="handleChange"
          :on-exceed="handleExceed"
          :http-request="handleSubmit"
          :auto-upload="false"
        >
          <template v-if="showDialogSave">
          <el-button slot="trigger" size="small" type="success">选择发票</el-button>
          </template>
        </el-upload>
      </el-form-item>
      <!--<el-form-item prop="received_date" label="收款日期">
        <el-date-picker
          v-model="formData.received_date"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>-->
      <el-form-item prop="remark" label="备注">
        <el-input v-model="formData.remark" autoComplete="on" type="textarea" :autosize="{minRows: 4, maxRows: 6}"></el-input>
      </el-form-item>

      <el-form-item>
        <span style="float: right">
          <template v-if="showDialogSave">
          <el-button size="small" @click="cancelData">取消</el-button>
          <el-button v-if="dialogStatus=='action.create'"
                     type="primary" size="small"
                     @click="saveData">保存</el-button>
          <el-button
              v-if="dialogStatus == 'action.edit' && (is_superuser ||(!is_superuser && !formData.is_superuser))"
              type="primary" size="small"
              @click="saveData">保存</el-button>
          </template>
        </span>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
  import { fetchReceivable, createReceivable, updateReceivable } from '@/api/billing'
  import { fetchSourceDocumentList, deleteSourceDocument} from '@/api/billing'
  import {
    fetchSettingCompanyAccountListByCompanyCode,
    fetchSettingCompanyAccountListByBranchOfficeCode
  } from '@/api/billing'
  import { getToken } from '@/utils/auth'
  import { EventBus } from "@/utils/event-bus"
  import { formatDate, formatDateTime } from '@/utils/misc'
  import { validateUsername, validatePassword, validateConfirmPassword, validateEmail, validateInvoiceNumber } from '@/utils/validate'

  export default {
    name: 'receivable-detail-dialog',
    filters: {
      formatDate
    },
    props: [
      'billing_file_id',
      'adjust_commission',
      'confirmed_amount',
      'unconfirmed_amount',
    ],
    data() {
      validateUsername
      validatePassword
      validateConfirmPassword
      validateEmail
      var validateAmount = (rule, value, callback) => {
        if(this.modify_unconfirmed_amount < 0.0) {
          return callback(new Error('未确认金额小于0'))
        } else {
          return callback()
        }
      };
      return {
        dialogStatus: null,
        dialogVisible: false,
        showDialogSave: true,
        is_superuser: undefined,
        titleLabel: {
          'action.create': '新增',
          'action.edit': '编辑'
        },
        options: [{
          value: 1,
          label: '公账'
        }, {
          value: 2,
          label: '私账'
        }],
        accountOptions: [],
        insuranceCompanyOptions:[],
        formData: {
          income_type: null,
          insurance_company: '',
          taxpayer_id: '',
          invoice_number: '',
          vat: 0,
          sales: 0,
          amount: 0,
          invoiced_amount: 0,
          non_invoiced_amount: 0,
          invoiced_date: null,
          received_date: null,
          account: '',
          billing_file: null
        },
        isDisabled: false,
        initAmount: 0.0,
        source_document_list:[],
        rules: {
          income_type: [
            {required: true, message:'请选择到收入类型' ,trigger: 'blur'},
          ],
          insurance_company: [
            {required: true, message:'请选择业务单位明细' ,trigger: 'blur'},
          ],
          amount: [
            {required: true, message:'请输入税价合计' ,trigger: 'blur'},
            {validator: validateAmount, trigger: 'blur'}
          ],
          invoiced_date: [
            {required: true, message:'请选择到账日期' ,trigger: 'blur'},
          ],
          invoice_number: [
            {required: true, trigger: 'blur', validator: validateInvoiceNumber},
          ],
          taxpayer_id: [
            {required: true, message:'请输入纳税人识别号' ,trigger: 'blur'},
          ],
          // first_name: [{required: true, message: '请填写用户名', trigger: 'blur'}],
          // email: [{required: true, trigger: 'blur', message: '请输入有效的邮箱地址', validator: validateEmail}],
          // password: [{required: true, trigger: 'blur', validator: validatePassword}]
        }
      }
    },
    computed: {
      vat: function () {
        let tempAmount = 0.0
        if (this.formData.amount !== null && this.formData.amount !== undefined && this.formData.amount !== '') {tempAmount = this.formData.amount}
        let result = (parseFloat(tempAmount) / parseFloat(1.06)) * parseFloat(0.06)
        return result.toFixed(4)
      },
      sales: function() {
        let tempAmount = 0.0
        if (this.formData.amount !== null && this.formData.amount !== undefined && this.formData.amount !== '') {tempAmount = this.formData.amount}
        let result = (parseFloat(tempAmount) - (parseFloat(tempAmount) / parseFloat(1.06)) * parseFloat(0.06))
        return result.toFixed(4)
      },
      invoiced_amount: function() {
        let result = 0.0
        let tempAmount = 0.0
        if (this.formData.amount !== null && this.formData.amount !== undefined && this.formData.amount !== '') {tempAmount = this.formData.amount}
        if (this.formData.income_type === 1){
            result = parseFloat(tempAmount)
        } else {
            result = 0.0
        }
        return result.toFixed(4)
      },
      non_invoiced_amount: function() {
        let result = 0.0
        let tempAmount = 0.0
        if (this.formData.amount !== null && this.formData.amount !== undefined && this.formData.amount !== '') {tempAmount = this.formData.amount}
        if (this.formData.income_type === 2){
            result = parseFloat(tempAmount)
        } else {
            result = 0.0
        }
        return result.toFixed(4)
      },
      modify_confirmed_amount: function(){
        if (this.formData.amount === null || this.formData.amount === undefined || this.formData.amount === '') {return this.confirmed_amount}
        let result = 0.0
        result = this.confirmed_amount + parseFloat(this.formData.amount) - this.initAmount
        return result.toFixed(4)
      },
      modify_unconfirmed_amount: function(){
        let result = 0.0
        result = this.adjust_commission - this.modify_confirmed_amount
        return result.toFixed(4)
      },
      headers() {
        return {'Authorization': 'Token ' + getToken()}
      }
    },
    methods: {
      resetFormData() {
        this.formData = {
          income_type: null,
          insurance_company: '',
          taxpayer_id: '',
          invoice_number: '',
          vat: 0,
          sales: 0,
          amount: 0,
          invoiced_amount: 0,
          non_invoiced_amount: 0,
          invoiced_date: null,
          received_date: null,
          account: '',
          billing_file: null
        }
        this.isDisabled = false,
        this.initAmount = 0.0
      },
      handleSelected(){
        console.log('insurance_company: ' + this.formData.insurance_company)
        let accountSelected = this.accountOptions.filter((account)=>{
            return account.label === this.formData.insurance_company
        })
        if (accountSelected !== null && accountSelected.length >= 0){
          this.formData.taxpayer_id = accountSelected[0].value
        }
        console.log('accountSelected :' + accountSelected[0].value )
      },
      handleCreate(branch_office_code) {
        console.log('handleCreate branch_office_code: ' + branch_office_code)
        this.getAccountOptions(branch_office_code)
        this.dialogStatus = 'action.create'
        this.dialogVisible = true
        this.is_superuser = this.$store.getters.is_superuser
        this.source_document_list = []
        this.resetFormData()
      },
      handleUpdate(id, branch_office_code, showDialogSave) {
        this.showDialogSave = showDialogSave
        console.log('handleUpdate branch_office: ' + branch_office_code)
        this.getAccountOptions(branch_office_code)
        this.dialogStatus = 'action.edit'
        let login_userid = this.$store.state.user.user
        this.id = id
        this.resetFormData()

        fetchReceivable(this.billing_file_id, this.id)
          .then(res => {
            this.formData = Object.assign({}, res)
            this.is_owner = (login_userid == id)
            this.dialogVisible = true
            this.isDisabled = true
            this.initAmount = this.formData.amount
            this.handleGetSourceDocumentList(this.id)
          })
          .catch(error => {
            this.$error_message(error)
          })
      },
      cancelData() {
        this.resetFormData()
        this.$nextTick(() => {
          this.$refs.dataForm.clearValidate()
        })
        this.dialogVisible = false
      },
      createData() {
        this.$refs['dataForm'].validate(valid => {
          if (valid) {
            this.formData.vat = this.vat
            this.formData.sales = this.sales
            this.formData.invoiced_amount = this.invoiced_amount
            this.formData.non_invoiced_amount = this.non_invoiced_amount
            this.formData.billing_file = this.billing_file_id
            createReceivable(this.formData, this.billing_file_id)
              .then(res => {
                this.$message.success(`新增收入成功, id=${res.id}`)
                this.$nextTick(() => {
                  this.dialogVisible = false
                  this.resetFormData()
                  this.$refs['dataForm'].clearValidate()
                  EventBus.$emit('created-receivable')
                })
              })
              .catch(error => {
                this.$error_message(error)
              })
          }
        })
      },
      getAccountOptions(branch_office_code) {
        console.log('getAccountOptions: ' + branch_office_code)
        fetchSettingCompanyAccountListByBranchOfficeCode(branch_office_code)
          .then(res=>{
            console.log(res)
            this.accountOptions = res
          }).catch(err=>{
            this.$error_message(err)
          })
      },
      updateData() {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            const formData = Object.assign({}, this.formData)
            formData.vat = this.vat
            formData.sales = this.sales
            formData.invoiced_amount = this.invoiced_amount
            formData.non_invoiced_amount = this.non_invoiced_amount
            formData.billing_file = this.billing_file_id
            updateReceivable(formData, this.billing_file_id, this.id)
              .then(() => {
                this.$message.success('修改收入信息成功')
                this.$refs.dataForm.resetFields()
                this.dialogVisible = false
                EventBus.$emit('updated-receivable')
              })
              .catch(error => {
                this.$error_message(error)
              })
          }
        })
      },
      handleGetSourceDocumentList(invoiceID) {
        fetchSourceDocumentList(invoiceID, 'billingreceivables')
          .then( resp=>{
            console.log(resp)
            this.source_document_list = resp
          }).catch( err=>{
            this.$error_message(err)
          })
      },
      handlePreviewSourceDocument(file) {
        window.open(file.url, "_blank")
      },
      handleRemoveSourceDocument(file, fileList) {
        console.log(file)
        this.source_document_list = fileList
        if (this.showDialogSave) {
          deleteSourceDocument(file.id)
            .then( resp=>{
              this.$message.success('发票已被删除')
            }).catch( err=>{
              this.$error_message(err)
            })
        }
      },
      handleChange(file, fileList) {
        this.source_document_list = fileList
      },
      handleExceed() {
        this.$message({ type:'warning', message:'只能上传1张发票'})
      },
      needSubmitWithSourceDocument() {
        // 检查是否有需要上传的文件存在,判断标准为组件upload的上传文件属性中是否存在raw字段
        let needUpload = false
        if (this.$refs.upload.uploadFiles.length > 0){
          for (let f of this.$refs.upload.uploadFiles){
            if ('raw' in f) {
              needUpload = true
              break
            }
          }
          return needUpload
        }
      },
      handleSubmit(param) {
        this.$refs['dataForm'].validate(valid => {
          if (valid) {
            const formData = Object.assign({}, this.formData)
            formData.vat = this.vat
            formData.sales = this.sales
            formData.invoiced_amount = this.invoiced_amount
            formData.non_invoiced_amount = this.non_invoiced_amount
            formData.billing_file = this.billing_file_id

            const fd = new FormData()
            for (let d in formData) {
              if (formData[d] === null) {continue}
              fd.set(d, formData[d])
            }

            let oldDate = new Date(this.formData.invoiced_date).getTime()
            let newDate = new Date(oldDate)
            fd.set('invoiced_date', formatDateTime(newDate))

            console.log(this.source_document_list.length)
            if (this.source_document_list.length > 0) {
              fd.set('is_uploaded', 1)
            }
            else {
              fd.set('is_uploaded', 0)
            }

            if (param !== null){
              let fileObj = param.file
              fd.append('file', fileObj)
            }

            if (this.dialogStatus === 'action.create') {
              createReceivable(fd, this.billing_file_id)
              .then(res => {
                this.$message.success(`新增收入成功, id=${res.id}`)
                this.$nextTick(() => {
                  this.dialogVisible = false
                  this.resetFormData()
                  this.$refs['dataForm'].clearValidate()
                  EventBus.$emit('created-receivable')
                })
              })
              .catch(error => {
                this.$error_message(error)
              })
            } else if (this.dialogStatus === 'action.edit') {
              updateReceivable(fd, this.billing_file_id, this.id)
              .then(() => {
                this.$message.success('修改收入信息成功')
                this.$refs.dataForm.resetFields()
                this.dialogVisible = false
                EventBus.$emit('updated-receivable')
              })
              .catch(error => {
                this.$error_message(error)
              })
            } else {
              this.$error_message('无效的操作')
            }
          }
        })
      },
      saveData(){
        this.$refs['dataForm'].validate(valid => {
          if (valid) {
            if (this.needSubmitWithSourceDocument()) {
              this.$refs.upload.submit()
            } else {
              this.handleSubmit(null)
            }
          }
        })
      }
    },
    mounted() {
      document.body.addEventListener("paste", function (event) {
        const data = event.clipboardData.getData("text");
        const result = data.replace(/[\n\t\r]/g, '|').split('|');
        console.log(result)
        // alert(result)
      })
    }
  }
</script>
